

export default {
    vi : {
        header: 'Lấy lại mật khẩu',
        description: 'Mã xác thực đã được gửi tới email của bạn. Vui lòng kiểm tra email và nhập chính xác mã vào ô dưới.',
        verificationCode: 'Mã xác thực',
        invalidVerificationCode: 'Mã xác thực không hợp lệ',
        login: 'Quay lại đăng nhập'
    },
    en: {
        header: 'Reset password',
        description: 'Verification code has just been sent to your email. Please check your email and enter correctly into the textfield below.',
        verificationCode: 'Verification code',
        invalidVerificationCode: 'Verification code is invalid',
        login: 'Back to login'
    }
};
